import { Tab, Tabs, TabsProps } from '@mui/material';
import { ReactNode, SyntheticEvent, useEffect, useState } from 'react';
import { WidgetType } from '../../../modules/layout/types/widgetType';
import { cssWhen } from '../../utils/themeUtils';
import classes from './Tabs.module.scss';

export interface TabItem {
  id: string;
  label: string | ReactNode;
  type?: WidgetType;
  icon?: React.ReactElement;
  iconPosition?: 'bottom' | 'end' | 'start' | 'top';
}

export interface NbTabsProps extends TabsProps {
  tabs: Array<TabItem>;
  onTabChange?: (index: number, tabItem: TabItem) => void;
  selected: number;
  labelRender?: (tab: TabItem) => string | ReactNode;
}

const tabTestIds: Partial<Record<WidgetType, string>> = {
  [WidgetType.OpenOrders]: 'open-orders-tab',
  [WidgetType.OrderLog]: 'order-log-tab',
};

export const NbTabs = ({ tabs, onTabChange, selected, labelRender, className, ...others }: NbTabsProps) => {
  const [selectedTab, setSelectedTab] = useState<number>(selected);

  useEffect(() => {
    setSelectedTab(selected);
  }, [selected]);

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
    if (onTabChange) {
      onTabChange(newValue, tabs[newValue]);
    }
  };

  return (
    <Tabs
      className={cssWhen(classes.tabs, [className, className!])}
      classes={{ root: classes.root }}
      value={selectedTab}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      {...others}
    >
      {tabs.map(tab => (
        <Tab
          className={classes.tabsItem}
          icon={tab.icon}
          iconPosition={tab.iconPosition ?? 'end'}
          key={tab.id}
          label={labelRender ? labelRender(tab) : tab.label}
          data-testid={tabTestIds[tab.type as WidgetType]}
        />
      ))}
    </Tabs>
  );
};
